import React from "react"
import Icons from "~/components/Icons"
import { useEditor, useZoomRatio } from "@agenteresolve/react"
import { useTimer } from "@layerhub-io/use-timer"
import useDesignEditorContext from "~/hooks/useDesignEditorContext"
import useAppContext from "~/hooks/useAppContext"
import { PanelType } from "~/constants/app-options"

function formatTime(ms: number) {
  const value = Number.isFinite(ms) && ms > 0 ? ms : 0
  return new Date(value).toISOString().slice(14, 19)
}

export default function () {
  const { time } = useTimer()
  const { maxTime } = useDesignEditorContext()
  const { setActivePanel } = useAppContext()
  const zoomRatio: number = useZoomRatio()
  const editor = useEditor()

  return (
    <div className="ar-bottom-bar">
      <div className="ar-bottom-group">
        <button
          className="ar-chip"
          type="button"
          onClick={() => setActivePanel("Layers" as PanelType)}
          title="Layers"
        >
          <Icons.Layers size={17} />
        </button>
        <span className="ar-chip ar-chip-static">
          <Icons.TimePast size={15} />
          {formatTime(time)} / {formatTime(maxTime)}
        </span>
      </div>

      <div className="ar-bottom-group">
        <button className="ar-chip" type="button" onClick={() => editor.zoom.zoomOut()} title="Zoom out">
          <Icons.RemoveCircleOutline size={17} />
        </button>
        <button
          className="ar-chip ar-zoom-value"
          type="button"
          onClick={() => editor.zoom.zoomToRatio(1)}
          title="Reset zoom"
        >
          {Math.round(zoomRatio * 100)}%
        </button>
        <button className="ar-chip" type="button" onClick={() => editor.zoom.zoomIn()} title="Zoom in">
          <Icons.AddCircleOutline size={17} />
        </button>
        <span className="ar-bottom-sep" />
        <button className="ar-chip" type="button" onClick={() => editor.history.undo()} title="Undo">
          <Icons.Undo size={18} />
        </button>
        <button className="ar-chip" type="button" onClick={() => editor.history.redo()} title="Redo">
          <Icons.Redo size={18} />
        </button>
      </div>
    </div>
  )
}
